import { CLICK_PROMO_BANNER, CLICK_PROMO_BANNER_DETAIL } from '~~/constants/googleTagManager';
import type { TriggerClickPromoBannerParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildClickPromoBannerTags = ({
  campaignName,
  pageCategory,
}: TriggerClickPromoBannerParameters) => ({
  event: CLICK_PROMO_BANNER,
  event_info: {
    detail: CLICK_PROMO_BANNER_DETAIL,
    campaign_name: campaignName,
    page_category: pageCategory,
  },
});
